module.exports = {
      id: "account-investments-usage",
      viewBox: "0 0 21.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-investments-usage",
      toString: function () {
        return this.url;
      }
    }